// ============================================
// TEMPLATE TAB CONTROLLER (FULL - WITH API TREE + JUMP DROPDOWN)
// ============================================

angular.module('bizmetryApp').controller('TemplateTabController', function (
    $scope, $rootScope, $timeout, $mdDialog, $mdToast,
    ProfileService, TemplateInstanceService, dialogService
) {

    console.log('🎨 TemplateTabController initialized');

    // ============================================
    // STATE
    // ============================================

    $scope.templateVersions = [];
    $scope.flatVersionTree = [];
    $scope.loadingTemplateVersions = false;

    // Live filter toggle — when ON shows only live versions as flat list
    $scope.liveFilterActive = false;
    $scope.liveVersions     = [];   // flat list of live nodes (no tree structure)

    $scope.toggleLiveFilter = function () {
        $scope.liveFilterActive = !$scope.liveFilterActive;
        if ($scope.liveFilterActive) {
            $scope._rebuildLiveVersions();
        }
    };

    $scope._rebuildLiveVersions = function () {
        $scope.liveVersions = $scope.flatVersionTree.filter(function (node) {
            return node.template.liveInfo && node.template.liveInfo.is_live;
        });
    };

    /**
     * Returns all environments assigned to this template version (from profile.environments),
     * enriched with a `live` flag by crossing with liveInfo.envs.
     * - assigned: env.templateInstanceId === template.id
     * - live:     env.id is present in liveInfo.envs
     *
     * Results are cached by template.id to avoid infinite digest loops — AngularJS
     * triggers a new digest whenever a function in ng-repeat returns a new array reference.
     */
    var _enrichedEnvsCache = {};

    $scope.getEnrichedEnvs = function (template) {
        if (!template || !template.id) return [];
        if (_enrichedEnvsCache[template.id]) return _enrichedEnvsCache[template.id];

        if (!$scope.profile || !Array.isArray($scope.profile.environments)) return [];

        var liveIds = {};
        if (template.liveInfo && Array.isArray(template.liveInfo.envs)) {
            template.liveInfo.envs.forEach(function (e) { liveIds[e.id] = true; });
        }

        var result = $scope.profile.environments
            .filter(function (env) { return env.templateInstanceId === template.id; })
            .map(function (env) {
                return { id: env.id, name: env.name, live: !!liveIds[env.id] };
            });

        _enrichedEnvsCache[template.id] = result;
        return result;
    };

    // Invalidate cache when the tree is reloaded
    $scope._clearEnrichedEnvsCache = function () {
        _enrichedEnvsCache = {};
    };

    $scope.confirmDeleteTemplateMap = {};
    $scope.deleteTemplateTimers = {};
    $scope.templatesInUseMap = {};

    $scope.versionSortOrder = 'ASC';

    // Tracks which template version is mid-transition (spinner + button disable)
    $scope.templateTransitioning = {};
    const TEMPLATE_DELETE_TIMEOUT_MS = 3000;

    // Object holder: the Jump-to md-select lives inside an ng-if (child scope);
    // a primitive ng-model would be written to that child scope and the
    // controller would keep scrolling to the previous value.
    $scope.versionJump = { selectedId: null };
    $scope.versionOptionsAsc = [];

    // ============================================
    // HELPERS
    // ============================================

    function pick(obj, a, b) {
        if (!obj) return null;
        return (obj[a] !== undefined && obj[a] !== null) ? obj[a] : obj[b];
    }

    function compareVersions(a, b) {
        function parse(v) {
            if (!v) return [0, 0, 0];
            return String(v).split('.').map(function (x) {
                var n = parseInt(x, 10);
                return isNaN(n) ? 0 : n;
            });
        }
        var A = parse(a), B = parse(b);
        var len = Math.max(A.length, B.length);
        for (var i = 0; i < len; i++) {
            var av = (A[i] !== undefined) ? A[i] : 0;
            var bv = (B[i] !== undefined) ? B[i] : 0;
            if (av < bv) return -1;
            if (av > bv) return 1;
        }
        return 0;
    }

    function findScrollableAncestor(el) {
        var node = el.parentElement;
        while (node && node !== document.documentElement) {
            var style = window.getComputedStyle(node);
            var overflow = style.overflow + style.overflowY;
            if (/auto|scroll/.test(overflow) && node.scrollHeight > node.clientHeight) {
                return node;
            }
            node = node.parentElement;
        }
        return document.documentElement;
    }

    // Position of el inside ancestor's scrollable content. Uses rects, not the
    // offsetParent chain: the tab's scroller isn't positioned, so that chain
    // skipped it and overshot (the row ended up clipped at the bottom).
    function getOffsetTopRelativeTo(el, ancestor) {
        if (ancestor === document.documentElement) {
            return el.getBoundingClientRect().top + window.pageYOffset;
        }
        return el.getBoundingClientRect().top - ancestor.getBoundingClientRect().top + ancestor.scrollTop;
    }

    // ============================================
    // IN-USE MAP
    // ============================================

    $scope.rebuildTemplatesInUseMap = function () {
        var map = {};
        var envs = ($scope.profile && Array.isArray($scope.profile.environments))
            ? $scope.profile.environments : [];

        envs.forEach(function (env) {
            if (env && env.templateInstanceId) {
                map[env.templateInstanceId] = true;
            }
        });

        $scope.templatesInUseMap = map;
    };

    $scope.rebuildTemplatesInUseMap();

    // ============================================
    // JUMP DROPDOWN
    // ============================================

    $scope.rebuildVersionOptionsAsc = function () {
        var opts = ($scope.templateVersions || []).slice();
        opts.sort(function (x, y) {
            return compareVersions(x.templateVersion, y.templateVersion);
        });
        $scope.versionOptionsAsc = opts;
    };

    $scope.scrollToTemplateVersion = function (templateId) {
        if (!templateId) return;

        $timeout(function () {
            var el = document.getElementById('vt-node-' + templateId);
            if (!el) {
                console.warn('⚠️ Node not found: vt-node-' + templateId);
                return;
            }

            var scroller = findScrollableAncestor(el);
            var elOffsetTop = getOffsetTopRelativeTo(el, scroller);
            var targetTop = elOffsetTop - (scroller.clientHeight / 2) + (el.offsetHeight / 2);

            scroller.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });

            el.classList.remove('vtrow--highlight-red');
            void el.offsetWidth;
            el.classList.add('vtrow--highlight-red');

            $timeout(function () {
                el.classList.remove('vtrow--highlight-red');
            }, 2200);

        }, 180);
    };

    $scope.onSelectTemplateVersion = function () {
        $scope.scrollToTemplateVersion($scope.versionJump.selectedId);
    };

    // ============================================
    // LOAD TEMPLATE TREE (API)
    // ============================================

    $scope.loadTemplateTree = function () {
        if ($scope.$$destroyed) return;

        if (!$scope.profile || !$scope.profile.id) {
            console.warn('⚠️ Cannot load template tree: No profile ID available');
            return;
        }

        $scope.loadingTemplateVersions = true;
        $scope.templateTreeError = null;

        ProfileService.getTemplateTree($scope.profile.id, $scope.versionSortOrder)
            .then(function (response) {
                if ($scope.$$destroyed) return;

                var data = response && response.data ? response.data : null;

                var root = data;
                if (root && root['template-tree']) root = root['template-tree'];
                if (root && root.templateTree) root = root.templateTree;

                if (!root || !root.id) {
                    $scope.templateVersions = [];
                    $scope.flatVersionTree = [];
                    $scope.versionOptionsAsc = [];
                    $scope.versionJump.selectedId = null;
                    $scope.rebuildTemplatesInUseMap();
                    return;
                }

                var flatTree = [];
                var byId = {};

                function walk(node, depth, parentNode) {
                    if (!node || !node.id) return;

                    var children = Array.isArray(node.children) ? node.children : [];

                    var templateShim = {
                        id: node.id,
                        templateVersion:       pick(node, 'version', 'templateVersion'),
                        templateStatus:        pick(node, 'status', 'templateStatus'),
                        createdBy:             pick(node, 'created_by', 'createdBy'),
                        updatedBy:             pick(node, 'updated_by', 'updatedBy'),
                        createdTs:             pick(node, 'created_ts', 'createdTs'),
                        updatedTs:             pick(node, 'updated_ts', 'updatedTs'),
                        parentTemplateId:      parentNode ? parentNode.id : null,
                        parentTemplateVersion: parentNode ? pick(parentNode, 'version', 'templateVersion') : null,
                        isDefaultVersion:      false,
                        // live_info from TemplateTreeService: { is_live: bool, envs?: [{id,name}] }
                        liveInfo:              node.live_info || null
                    };

                    byId[templateShim.id] = templateShim;

                    flatTree.push({
                        template:    templateShim,
                        depth:       depth,
                        hasChildren: children.length > 0
                    });

                    children.forEach(function (c) {
                        walk(c, depth + 1, node);
                    });
                }

                walk(root, 0, null);

                if (flatTree.length > 0) {
                    flatTree[0].template.isDefaultVersion = true;
                }

                $scope.flatVersionTree = flatTree;
                $scope.templateVersions = Object.keys(byId).map(function (k) { return byId[k]; });

                // Refresh live-filter list in case toggle is already active
                $scope._rebuildLiveVersions();

                // Invalidate enriched-envs cache so tags reflect the fresh data
                $scope._clearEnrichedEnvsCache();

                $scope.rebuildVersionOptionsAsc();

                if (!$scope.versionJump.selectedId || !byId[$scope.versionJump.selectedId]) {
                    $scope.versionJump.selectedId = flatTree.length > 0 ? flatTree[0].template.id : null;
                }

                $scope.rebuildTemplatesInUseMap();
            })
            .catch(function (error) {
                if ($scope.$$destroyed) return;

                console.error('❌ Error loading template tree:', error);
                $scope.templateTreeError = (error && error.data && (error.data.message || error.data.error)) ||
                    'The template tree could not be loaded. Please try again later.';
                $scope.templateVersions = [];
                $scope.flatVersionTree = [];
                $scope.versionOptionsAsc = [];
                $scope.versionJump.selectedId = null;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Failed to load template tree')
                        .position('top right')
                        .hideDelay(3000)
                );
            })
            .finally(function () {
                if (!$scope.$$destroyed) {
                    $scope.loadingTemplateVersions = false;
                }
            });
    };

    // ============================================
    // SORT TOGGLE
    // ============================================

    $scope.toggleVersionSortOrder = function () {
        $scope.versionSortOrder = ($scope.versionSortOrder === 'DESC') ? 'ASC' : 'DESC';
        $scope.loadTemplateTree();
    };

    // ============================================
    // EDIT TEMPLATE VERSION
    // ============================================

    $scope.editTemplateVersion = function (templateVersion) {
        if (templateVersion && templateVersion.client_types) {
            openTemplateModal(
                templateVersion,
                'EditTemplateDialogController',
                'template/edit-template-dialog.html',
                'edit-template-btn',
                { profile: $scope.profile }
            );
            return;
        }

        if (templateVersion && templateVersion.id) {
            TemplateInstanceService.getTemplateInstanceById(templateVersion.id)
                .then(function (response) {
                    openTemplateModal(
                        response.data,
                        'EditTemplateDialogController',
                        'template/edit-template-dialog.html',
                        'edit-template-btn',
                        { profile: $scope.profile }
                    );
                })
                .catch(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error fetching template instance for edit')
                            .position('top right')
                            .hideDelay(3000)
                    );
                });
        }
    };

    // ============================================
    // TEMPLATE EXPLORER
    // ============================================

    $scope.openTemplateVersionExplorer = function (templateVersion) {
        try {
            TemplateInstanceService.getTemplateInstanceById(templateVersion.id)
                .then(function (response) {
                    var template = response && response.data ? response.data : {};

                    $mdDialog.show({
                        controller:        'TreeTemplateViewController',
                        templateUrl:       'template/treeView/tree-template-view.html',
                        parent:            angular.element(document.body),
                        escapeToClose:     false,
                        clickOutsideToClose: true,
                        multiple:          true,
                        locals:            { templateInstance: template }
                    });
                })
                .catch(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Error opening template explorer')
                            .position('top right')
                            .hideDelay(3000)
                    );
                });
        } catch (err) {
            console.error('Excepción en openTemplateVersionExplorer:', err);
        }
    };

    // ============================================
    // PROMOTE / REJECT / RETIRE
    // Sin dialog de confirmación — ejecutar directamente
    // ============================================

    $scope.hasBeenModifiedAfterRejection = function (templateVersion) {
        if (templateVersion.rejectedEtag && templateVersion.etag) {
            return templateVersion.etag !== templateVersion.rejectedEtag;
        }
        return false;
    };

    $scope.getPromoteButtonLabel = function (templateVersion) {
        var labels = {
            'DRAFT':          'Submit for Review',
            'PENDING_REVIEW': 'Approve',
            'REVIEWED':       'Publish',
            'REJECTED':       'Resubmit for Review'
        };
        return labels[templateVersion.templateStatus] || 'Promote';
    };

    $scope.getPromoteButtonIcon = function (templateVersion) {
        var icons = {
            'DRAFT':          'send',
            'PENDING_REVIEW': 'check_circle',
            'REVIEWED':       'publish',
            'REJECTED':       'refresh'
        };
        return icons[templateVersion.templateStatus] || 'arrow_upward';
    };

    // ── Publishing needs every associated API collection version PUBLISHED ──
    // Loaded for REVIEWED versions (the ones Publish applies to); the button is
    // disabled with the reason until the server says they're all PUBLISHED.
    $scope.publishBlockers = {};   // templateId → [reason] (absent while unknown)

    $scope.$watch(function () {
        return ($scope.flatVersionTree || [])
            .filter(function (n) { return n.template.templateStatus === 'REVIEWED'; })
            .map(function (n) { return n.template.id; }).join(',');
    }, function (ids) {
        (ids ? ids.split(',') : []).forEach(function (id) {
            TemplateInstanceService.getApiCollections(id, { skipLoader: true })
                .then(function (res) {
                    $scope.publishBlockers[id] = (res.data && res.data.publish_blockers) || [];
                })
                .catch(function () { delete $scope.publishBlockers[id]; });
        });
    });

    $scope.isPublishBlocked = function (templateVersion) {
        if (templateVersion.templateStatus !== 'REVIEWED') { return false; }
        var blockers = $scope.publishBlockers[templateVersion.id];
        return !blockers || blockers.length > 0;   // unknown yet → wait
    };

    $scope.getPromoteButtonTooltip = function (templateVersion) {
        if (!$scope.isPublishBlocked(templateVersion)) { return $scope.getPromoteButtonLabel(templateVersion); }
        var blockers = $scope.publishBlockers[templateVersion.id];
        return blockers
            ? 'Can\'t publish until its API collections are PUBLISHED: ' + blockers.join('; ')
            : 'Checking API collections…';
    };

    $scope.canPromoteTemplate = function (templateVersion) {
        if (templateVersion.templateStatus === 'PUBLISHED') return false;
        if (templateVersion.templateStatus === 'RETIRED')   return false;
        if (templateVersion.templateStatus === 'REJECTED') {
            return $scope.hasBeenModifiedAfterRejection(templateVersion);
        }
        return true;
    };

    $scope.canRetireTemplate = function (templateVersion) {
        return templateVersion.templateStatus === 'PUBLISHED'
            && !$scope.templatesInUseMap[templateVersion.id];
    };

    var PROMOTE_TRANSITIONS = {
        'DRAFT':          'PENDING_REVIEW',
        'PENDING_REVIEW': 'REVIEWED',
        'REVIEWED':       'PUBLISHED',
        'REJECTED':       'PENDING_REVIEW'
    };

    // Permissions the promote button needs (bm-requires-all), by the status it moves to.
    $scope.promotePermissions = function (templateVersion) {
        // $rootScope explicitly: the profile dialog's scope doesn't inherit root properties.
        return $rootScope.lifecyclePermissions('TEMPLATE_VERSION', PROMOTE_TRANSITIONS[templateVersion.templateStatus]);
    };

    $scope.promoteTemplateVersion = function (templateVersion) {
        if ($scope.isPublishBlocked(templateVersion)) { return; }
        var currentStatus = templateVersion.templateStatus;
        var nextStatus = PROMOTE_TRANSITIONS[currentStatus];

        if (!nextStatus) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Template is already in a final status (' + currentStatus + ')')
                    .position('top right')
                    .hideDelay(3000)
            );
            return;
        }

        if (currentStatus === 'REJECTED' && !$scope.hasBeenModifiedAfterRejection(templateVersion)) {
            dialogService.showErrorDialog(
                'Cannot Resubmit',
                'This template was rejected and must be modified before it can be resubmitted for review.<br><br>' +
                'Please edit the template to make the necessary changes first.'
            );
            return;
        }

        _doTransitionTemplateStatus(templateVersion, nextStatus);
    };

    $scope.retireTemplateVersion = function (templateVersion) {
        if (!$scope.canRetireTemplate(templateVersion)) return;
        _doTransitionTemplateStatus(templateVersion, 'RETIRED');
    };

    $scope.rejectTemplateVersion = function (templateVersion) {
        _doTransitionTemplateStatus(templateVersion, 'REJECTED');
    };

    // REJECTED → DRAFT: back to editing without resubmitting (the backend only
    // requires the base EDIT_TEMPLATE_VERSION for a DRAFT target).
    $scope.reopenTemplateVersionAsDraft = function (templateVersion) {
        _doTransitionTemplateStatus(templateVersion, 'DRAFT');
    };

    // ============================================
    // IN-PLACE STATUS TRANSITION (no full-tree reload)
    // Mirrors the biz-events _doTransitionVersionStatus pattern:
    //   PATCH → getById → update only the affected node in flatVersionTree
    //   → refresh derived state (liveVersions, enriched-envs cache, in-use map)
    // No loadingTemplateVersions flag is set — the row shows its own spinner via
    // $scope.templateTransitioning[id], so the list never flickers.
    // ============================================

    function _doTransitionTemplateStatus(templateVersion, targetStatus) {
        var id = templateVersion.id;

        // Mark row as transitioning — template.html can bind ng-disabled / spinner to this
        $scope.templateTransitioning[id] = true;

        TemplateInstanceService.patchTemplateInstance(id, { templateStatus: targetStatus })
            .then(function () {
                // Fetch only the affected version from the server — single source of truth.
                return TemplateInstanceService.getTemplateInstanceById(id).then(function (res) {
                    var fresh = res && res.data ? res.data : null;
                    if (!fresh) { return; }

                    // Normalise to the same shim shape used by the walk() function in loadTemplateTree
                    var freshStatus  = fresh.templateStatus  || fresh.status      || targetStatus;
                    var freshUpdBy   = fresh.updatedBy       || fresh.updated_by  || templateVersion.updatedBy;
                    var freshUpdTs   = fresh.updatedTs       || fresh.updated_ts  || templateVersion.updatedTs;
                    var freshLiveInfo = fresh.live_info      || fresh.liveInfo     || templateVersion.liveInfo;
                    var freshEtag    = fresh.etag            != null ? fresh.etag  : templateVersion.etag;
                    var freshRejEtag = fresh.rejectedEtag    != null ? fresh.rejectedEtag : templateVersion.rejectedEtag;

                    // Update the node in flatVersionTree (drives the ng-repeat)
                    var treeNode = $scope.flatVersionTree.find(function (n) {
                        return n.template.id === id;
                    });
                    if (treeNode) {
                        treeNode.template.templateStatus = freshStatus;
                        treeNode.template.updatedBy      = freshUpdBy;
                        treeNode.template.updatedTs      = freshUpdTs;
                        treeNode.template.liveInfo       = freshLiveInfo;
                        treeNode.template.etag           = freshEtag;
                        treeNode.template.rejectedEtag   = freshRejEtag;
                    }

                    // Keep templateVersions in sync (used by jump dropdown, diff, etc.)
                    var verNode = $scope.templateVersions.find(function (t) {
                        return t.id === id;
                    });
                    if (verNode) {
                        verNode.templateStatus = freshStatus;
                        verNode.updatedBy      = freshUpdBy;
                        verNode.updatedTs      = freshUpdTs;
                        verNode.liveInfo       = freshLiveInfo;
                        verNode.etag           = freshEtag;
                        verNode.rejectedEtag   = freshRejEtag;
                    }

                    // Refresh derived state that depends on status / liveInfo
                    $scope._rebuildLiveVersions();
                    $scope._clearEnrichedEnvsCache();
                    $scope.rebuildTemplatesInUseMap();

                    // Notify sibling tabs (environments tab needs to know)
                    refreshEnvironmentsTab();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('✅ Template updated to ' + targetStatus.replace(/_/g, ' '))
                            .position('top right')
                            .hideDelay(2500)
                    );
                });
            })
            .catch(function (error) {
                dialogService.showErrorDialog(
                    'Status Update Failed',
                    'Failed to update template version status. ' +
                    (error.data && error.data.message ? error.data.message : 'Unknown error')
                );
            })
            .finally(function () {
                delete $scope.templateTransitioning[id];
            });
    }

    // ============================================
    // DELETE VERSION
    // ============================================

    $scope.isTemplateInProductionUse = function (templateVersion) {
        return !!$scope.templatesInUseMap[templateVersion.id];
    };

    $scope.getProductionEnvironmentsUsingTemplate = function (templateVersion) {
        if (!$scope.profile || !$scope.profile.environments) return [];
        return $scope.profile.environments.filter(function (env) {
            return env.templateInstanceId === templateVersion.id;
        });
    };

    $scope.getTemplateDeleteTooltip = function (templateVersion) {
        if (!!$scope.templatesInUseMap[templateVersion.id]) {
            var envs = $scope.getProductionEnvironmentsUsingTemplate(templateVersion);
            var envNames = envs.map(function (e) { return e.name; }).join(', ');
            return 'Cannot delete: assigned to environment(s): ' + envNames;
        }
        return $scope.confirmDeleteTemplateMap[templateVersion.id]
            ? 'Confirming deletion...'
            : 'Delete template version';
    };

    $scope.deleteTemplateVersion = function (templateVersion) {
        if ($scope.isTemplateInProductionUse(templateVersion)) {
            var envs = $scope.getProductionEnvironmentsUsingTemplate(templateVersion);
            var envNames = envs.map(function (e) { return e.name; }).join(', ');
            dialogService.showErrorDialog(
                'Cannot Delete Template',
                'This template version <strong>' + templateVersion.templateVersion +
                '</strong> is currently assigned to: <strong>' + envNames + '</strong>.<br><br>' +
                'Please unassign the template from these environments before deleting.'
            );
            return;
        }

        var tid = templateVersion.id;

        if (!$scope.confirmDeleteTemplateMap[tid]) {
            // 1er click — marcar en rojo, arrancar timer de reset
            $scope.confirmDeleteTemplateMap[tid] = true;
            if ($scope.deleteTemplateTimers[tid]) { $timeout.cancel($scope.deleteTemplateTimers[tid]); }
            $scope.deleteTemplateTimers[tid] = $timeout(function () {
                $scope.confirmDeleteTemplateMap[tid] = false;
                delete $scope.deleteTemplateTimers[tid];
            }, TEMPLATE_DELETE_TIMEOUT_MS);

        } else {
            // 2do click — cancelar timer, resetear flag, abrir dialog de confirmación
            $timeout.cancel($scope.deleteTemplateTimers[tid]);
            delete $scope.deleteTemplateTimers[tid];
            $scope.confirmDeleteTemplateMap[tid] = false;

            dialogService.showConfirmationDialog(
                'Delete Template Version',
                'You are about to permanently delete template version <strong>v' +
                templateVersion.templateVersion + '</strong>. This cannot be undone.',
                'v' + templateVersion.templateVersion,
                true
            ).then(function (decision) {
                if (decision !== 'confirmed') return;

                TemplateInstanceService.deleteTemplateInstance(templateVersion.id)
                    .then(function () {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('✅ Template version deleted successfully')
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.loadTemplateTree();
                        refreshEnvironmentsTab();
                    })
                    .catch(function (error) {
                        dialogService.showErrorDialog(
                            'Delete Failed',
                            'Failed to delete template version. ' +
                            (error.data && error.data.message ? error.data.message : 'Unknown error')
                        );
                    });
            });
        }
    };

    // ============================================
    // DIFF
    // ============================================

    $scope.openTemplateDiff = function (childTemplate) {
        var parentTemplate = null;
        if (childTemplate.parentTemplateId) {
            parentTemplate = $scope.templateVersions.find(function (t) {
                return t.id === childTemplate.parentTemplateId;
            });
        }

        $mdDialog.show({
            controller:          'TemplateDiffDialogController',
            templateUrl:         'profile/tabs/template/diff/template-diff-dialog.html',
            parent:              angular.element(document.body),
            escapeToClose:       true,
            clickOutsideToClose: true,
            multiple:            true,
            locals: {
                childTemplateRef:  childTemplate,
                parentTemplateRef: parentTemplate
            }
        });
    };

    // ============================================
    // CASCADE DELETE
    // ============================================

    $scope.getAllDescendants = function (node) {
        var descendants = [];
        var queue = [node.template.id];

        while (queue.length > 0) {
            var currentId = queue.shift();
            $scope.flatVersionTree.forEach(function (n) {
                if (n.template.parentTemplateId === currentId) {
                    descendants.push(n);
                    queue.push(n.template.id);
                }
            });
        }
        return descendants;
    };

    $scope.canCascadeDelete = function (node) {
        if (!node.hasChildren) return false;
        var descendants = $scope.getAllDescendants(node);
        return descendants.every(function (d) {
            return !$scope.templatesInUseMap[d.template.id];
        });
    };

    $scope.getCascadeDeleteTooltip = function (node) {
        if (!node.hasChildren) return '';

        if (!$scope.canCascadeDelete(node)) {
            var blocked = $scope.getAllDescendants(node)
                .filter(function (d) { return !!$scope.templatesInUseMap[d.template.id]; })
                .map(function (d) { return 'v' + d.template.templateVersion; })
                .join(', ');
            return 'Cannot cascade delete: ' + blocked + ' assigned to environment(s)';
        }

        var count = $scope.getAllDescendants(node).length;
        return 'Delete this version and ' + count + ' descendant(s)';
    };

    $scope.deleteTemplateVersionCascade = function (node) {
        if (!$scope.canCascadeDelete(node)) return;

        var descendants = $scope.getAllDescendants(node);
        var versionList = [node].concat(descendants)
            .map(function (n) { return '<li>v' + n.template.templateVersion + '</li>'; })
            .join('');

        dialogService.showDecisionDialog(
            'Delete Version Tree',
            'This will permanently delete <strong>v' + node.template.templateVersion +
            '</strong> and all its descendants:<br><br>' +
            '<ul style="margin: 8px 0 0 16px; padding: 0;">' + versionList + '</ul>' +
            '<br>This action cannot be undone.'
        ).then(function (decision) {
            if (decision !== 'proceed') return;

            TemplateInstanceService.deleteTemplateInstanceCascade(node.template.id)
                .then(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('✅ Template version tree deleted successfully')
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.loadTemplateTree();
                    refreshEnvironmentsTab();
                })
                .catch(function (error) {
                    dialogService.showErrorDialog(
                        'Cascade Delete Failed',
                        'Failed to delete template version tree. ' +
                        (error.data && error.data.message ? error.data.message : 'Unknown error')
                    );
                });
        });
    };

    // ============================================
    // PRIVATE UTILS
    // ============================================

    function openTemplateModal(templateInstance, ctrl, url, focusBtnId, additionalLocals) {
        var dialogEl = document.querySelector('.profile-details-dialog');
        if (dialogEl) dialogEl.classList.add('md-dialog-is-blurred');

        var locals = {
            templateInstance: templateInstance,
            profileId:        $scope.profile.id,
            accountId:        $scope.profile.accountId
        };

        if (additionalLocals) angular.extend(locals, additionalLocals);

        $mdDialog.show({
            controller:          ctrl,
            templateUrl:         url,
            parent:              angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose:       false,
            multiple:            true,
            locals:              locals
        })
            .then(function () {
                $scope.loadTemplateTree();
            })
            .finally(function () {
                if (dialogEl) dialogEl.classList.remove('md-dialog-is-blurred');
                setTimeout(function () {
                    var btn = document.getElementById(focusBtnId);
                    if (btn) btn.focus();
                }, 250);
            });
    }

    function refreshEnvironmentsTab() {
        if ($scope.$$destroyed) return;
        $scope.$emit('template:statusChanged');
        if ($scope.$parent && typeof $scope.$parent.loadEnvironments === 'function') {
            $scope.$parent.loadEnvironments();
        }
        $scope.$broadcast('template:statusChanged');
    }

    // ============================================
    // LIVE INFO HELPER
    // ============================================

    /**
     * Returns a human-readable env name string for the live dot tooltip.
     * e.g. "Development · Production"
     */
    $scope.getLiveEnvNames = function (liveInfo) {
        if (!liveInfo || !Array.isArray(liveInfo.envs) || !liveInfo.envs.length) return '';
        return liveInfo.envs.map(function (e) { return e.name; }).join(' · ');
    };

    // ============================================
    // INIT
    // ============================================

    $scope.loadTemplateTree();

    $scope.$on('template:statusChanged', function () {
        $scope.rebuildTemplatesInUseMap();
    });

    // ============================================
    // CLEANUP
    // ============================================

    $scope.$on('$destroy', function () {
        Object.keys($scope.deleteTemplateTimers).forEach(function (key) {
            if ($scope.deleteTemplateTimers[key]) $timeout.cancel($scope.deleteTemplateTimers[key]);
        });
        $scope.confirmDeleteTemplateMap    = {};
        $scope.deleteTemplateTimers        = {};
        $scope.templateTransitioning       = {};
        $scope.loadingTemplateVersions     = false;
        $scope.templateVersions            = [];
        $scope.flatVersionTree             = [];
        $scope.versionOptionsAsc           = [];
        $scope.versionJump.selectedId   = null;
    });

    $scope.$on('tabChanged', function () {
        Object.keys($scope.deleteTemplateTimers).forEach(function (key) {
            if ($scope.deleteTemplateTimers[key]) $timeout.cancel($scope.deleteTemplateTimers[key]);
        });
        $scope.confirmDeleteTemplateMap = {};
        $scope.deleteTemplateTimers     = {};
    });

    var TEMPLATE_TAB_INDEX = 2;

    $scope.$on('profile:tabActivated', function (event, tabIndex) {
        if (tabIndex !== TEMPLATE_TAB_INDEX) return;
        console.log('🔄 Template tab activated — refreshing tree and in-use map');
        $scope.loadTemplateTree();
        $scope.rebuildTemplatesInUseMap();
    });

});